import InputPrefix from './input-prefix';

export default InputPrefix;
